import { TDropItem } from 'src/types';

export const boardExamOptions: TDropItem[] = [
  { value: 'administeredTestAp', label: 'AP' },
  { value: 'administeredTestPsat', label: 'PSAT' },
  { value: 'administeredTestSat', label: 'SAT' },
  { value: 'administeredTestOther', label: 'Other' },
  { value: 'administeredTestNone', label: 'None' },
];
